import React, { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import DrugsAndPrescription from "../accordions/DrugsAndPrescription";
import { useDrugs } from "../../context/manageDrugs";

const DrugsTab = () => {
  const { drugs, loading, handleFetchDrugs } = useDrugs();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (!drugs?.result?.length) {
      handleFetchDrugs();
    }
  }, []);

  const filteredData = useMemo(
    () =>
      (Array.isArray(drugs?.result) ? drugs.result : []).filter(
        (item) =>
          item?.patient?.hmo?.name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
          item?.requestType?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
          item?.item?.vaccine?.name_of_vaccine?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
          item?.requests?.some((request) =>
            request?.item?.drug?.name?.toLowerCase()?.includes(searchQuery.toLowerCase())
          )
      ),
    [drugs, searchQuery]
  );

  return (
    <>
      <div id="drugs" className="data-panel-head">
        <div className="data-panel-copy">
          <h5>Drugs & prescription</h5>
          <p>Search prescription records, then expand each entry to see medication, duration, refillability, and payment details.</p>
        </div>
        <div className="data-panel-actions">
          <div className="data-search">
            <Form.Control
              type="text"
              placeholder="Search plan, request type, or medication"
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="data-table-shell">
        <DrugsAndPrescription loading={loading} searchQuery={searchQuery} filteredData={filteredData} />
      </div>
    </>
  );
};

export default DrugsTab;
